import { Box } from '@mui/material';
import BannerCustomLink from '../../../../../../../components/BannerCustomLink';
import { BANNER_ASPECT_RATIO } from '../bannerCarousel.consts';
import { BannerSlide } from '../bannerCarousel.types';

interface BannerSlideItemProps {
  slide: BannerSlide;
}

const BannerSlideItem = ({ slide }: BannerSlideItemProps) => {
  const image = (
    <Box
      component="img"
      src={slide.imageUrl}
      alt={slide.name}
      loading="lazy"
      sx={{ display: 'block', width: '100%', aspectRatio: BANNER_ASPECT_RATIO, objectFit: 'cover' }}
    />
  );

  if (!slide.link) {
    return image;
  }

  return (
    <BannerCustomLink href={slide.link} style={{ display: 'block' }}>
      {image}
    </BannerCustomLink>
  );
};

export default BannerSlideItem;
